import { FlyoutComponent } from './flyout.component';
import { SharedModule } from '../shared/shared.module';
import { FlyoutStarScoringComponent } from './flyout-star-scoring/flyout-star-scoring.component';
import { FlyoutHeadlineComponent } from './flyout-headline/flyout-headline.component';
import { FlyoutTimeOverviewComponent } from './flyout-time-overview/flyout-time-overview.component';
import { FlyoutTagsComponent } from './flyout-tags/flyout-tags.component';
import { FlyoutContactInformationComponent } from './flyout-contact-information/flyout-contact-information.component';
import { FlyoutCampaignInformationComponent } from './flyout-campaign-information/flyout-campaign-information.component';
import { FlyoutUtmCampaignsComponent } from './flyout-utm-campaigns/flyout-utm-campaigns.component';
import { FlyoutGoalsComponent } from './flyout-goals/flyout-goals.component';
import { FlyoutDistributedCouponsComponent } from './flyout-distributed-coupons/flyout-distributed-coupons.component';
import { FlyoutActionListComponent } from './flyout-action-list/flyout-action-list.component';
import { FlyoutDeviceInfoComponent } from './flyout-device-info/flyout-device-info.component';
import { FlyoutGeneralInfoComponent } from './flyout-general-info/flyout-general-info.component';
import { FlyoutSessionsComponent } from './flyout-sessions/flyout-sessions.component';
import { FlyoutConsentListComponent } from './flyout-consent-list/flyout-consent-list.component';
import { FlyoutInterestProfileChartComponent } from './flyout-interest-profile-chart/flyout-interest-profile-chart.component';
import { FlyoutSourceComponent } from './flyout-source/flyout-source.component';
import { FlyoutAudienceComponent } from './flyout-audience/flyout-audience.component';
import { FlyoutAudienceHubComponent } from './flyout-audience-hub/flyout-audience-hub.component';
import { AudienceTrendChartComponent } from './flyout-audience-hub/audience-trend-chart/audience-trend-chart.component';
import { AudienceRuleEditorComponent } from './flyout-audience-hub/audience-rule-editor/audience-rule-editor.component';
import { AudienceInlineEditorComponent } from './flyout-audience-hub/audience-inline-editor/audience-inline-editor.component';
import { FilterItemDialogComponent } from './filter-item-dialog/filter-item-dialog.component';
import { SessionConditionDialogComponent } from './session-condition-dialog/session-condition-dialog.component';
import { ProfileUnmergeDialogComponent } from './profile-unmerge-dialog/profile-unmerge-dialog.component';
import { FlyoutSessionOnWidgetComponent } from './flyout-session-on-widget/flyout-session-on-widget.component';
import { FlyoutAutomationHistoryComponent } from './flyout-automation-history/flyout-automation-history.component';
import { FlyoutEditResponseListComponent } from './flyout-edit-response-list/flyout-edit-response-list.component';
import { FlyoutUpgradeAccountComponent } from './flyout-upgrade-account/flyout-upgrade-account.component';
import { WidgetAutomationsDataService } from 'app/campaign/widget-automations-data.service';
import { WidgetEditorDataService } from 'app/campaign/widget-editor-data.service';
import { AutomationsService } from 'app/automations/automations.service';
import { CreateAutomationService } from 'app/automations/create-automation/create-automation.service';
import { FlyoutReferralCampaignsComponent } from './flyout-referral-campaigns/flyout-referral-campaigns.component';
import { FlyoutSubmittedFormComponent } from './flyout-submitted-form/flyout-submitted-form.component';
import { FlyoutScoresComponent } from './flyout-scores/flyout-scores.component';
import { FlyoutFormSettingsV2Component } from './flyout-form-settings-v2/flyout-form-settings-v2.component';
import { FlyoutFormSettingsShowMessageComponent } from './flyout-form-settings-v2/show-message/flyout-form-settings-show-message.component';
import { FlyoutFormSettingsFormOptionsComponent } from './flyout-form-settings-v2/form-options/flyout-form-settings-form-options.component';
import { FlyoutFormSettingsResponseListsComponent } from './flyout-form-settings-v2/response-lists/flyout-form-settings-response-lists.component';
import { FlyoutFormSettingsLeaderboardComponent } from './flyout-form-settings-v2/leaderboard/flyout-form-settings-leaderboard.component';
import { FlyoutFormSettingsEcommerceComponent } from './flyout-form-settings-v2/ecommerce/flyout-form-settings-ecommerce.component';
import { AutomationSerializer } from './flyout-form-settings-v2/services/automation-serializer';
import { FlyoutAutomationsComponent } from './flyout-automations/flyout-automations.component';
import { FlyoutCampaignFilterComponent } from './flyout-campaign-filter/flyout-campaign-filter.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FlyoutBrandSettingsComponent } from './flyout-brand-settings/flyout-brand-settings.component';
import { FlyoutWidgetPreviewIframeComponent } from 'app/flyout/widget-preview/flyout-widget-preview.component';
import { FlyoutCopyBrandSettingsComponent } from './flyout-copy-brand-settings/flyout-copy-brand-settings.component';
import { DataPlatformConsentListComponent } from './data-platform-consent-list/data-platform-consent-list.component';
import { DataPlatformPurchasesListComponent } from './data-platform-purchases-list/data-platform-purchases-list.component';
import { DataPlatformVisitFlyoutComponent } from './data-platform-visit-flyout/data-platform-visit-flyout.component';
import { DataPlatformProfileFlyoutComponent } from './data-platform-profile-flyout/data-platform-profile-flyout.component';
import { DataPlatformContactFlyoutComponent } from './data-platform-contact-flyout/data-platform-contact-flyout.component';
import { CollapsibleListComponent } from './collapsible-list/collapsible-list.component';
import { FlyoutWidgetSelectorFilterComponent } from './flyout-widget-selector-filter/flyout-widget-selector-filter.component';
import { FlyoutHoldoutSettingsComponent } from './flyout-holdout-settings/flyout-holdout-settings.component';
import { FlyoutKpiSettingsComponent } from './flyout-kpi-settings/flyout-kpi-settings.component';
import { FlyoutRecommendationComponent } from './flyout-recommendation/flyout-recommendation.component';
import { FlyoutSiteCheckComponent } from './flyout-site-check/flyout-site-check.component';
import { DataPlatformService } from '../data-platform/data-platform.service';
import { FormatDate } from '../shared/pipes/format-date.pipe';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { UpgradeTierComponent } from 'app/account-settings/components/account-settings-upgrade-plan/upgrade-tier-dialog/upgrade-tier/upgrade-tier.component';
import { OutcomeLogicService } from '../campaign/widget-editor/outcome-logic.service';
import { NoCspSupportInfoComponent } from 'app/shared/no-csp-support-info/no-csp-support-info/no-csp-support-info.component';
const modules = [SharedModule];

// Exported components
const components = [FlyoutComponent];

// Exported services
const services = [
  WidgetAutomationsDataService,
  WidgetEditorDataService,
  AutomationsService,
  CreateAutomationService,
  OutcomeLogicService,
  AutomationSerializer,
];

@NgModule({
  imports: [
    ...modules,
    MatButtonToggleModule,
    MatTabsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    UpgradeTierComponent,
    NoCspSupportInfoComponent,
  ],
  exports: [...modules, ...components],
  declarations: [
    ...components,
    FlyoutStarScoringComponent,
    FlyoutHeadlineComponent,
    FlyoutTimeOverviewComponent,
    FlyoutTagsComponent,
    FlyoutContactInformationComponent,
    FlyoutCampaignInformationComponent,
    FlyoutUtmCampaignsComponent,
    FlyoutGoalsComponent,
    FlyoutDistributedCouponsComponent,
    FlyoutActionListComponent,
    FlyoutDeviceInfoComponent,
    FlyoutGeneralInfoComponent,
    FlyoutSessionsComponent,
    FlyoutConsentListComponent,
    FlyoutInterestProfileChartComponent,
    FlyoutSourceComponent,
    FlyoutAudienceComponent,
    FlyoutAudienceHubComponent,
    AudienceTrendChartComponent,
    AudienceRuleEditorComponent,
    AudienceInlineEditorComponent,
    FilterItemDialogComponent,
    SessionConditionDialogComponent,
    ProfileUnmergeDialogComponent,
    FlyoutSessionOnWidgetComponent,
    FlyoutAutomationHistoryComponent,
    FlyoutEditResponseListComponent,
    FlyoutUpgradeAccountComponent,
    FlyoutFormSettingsV2Component,
    FlyoutFormSettingsShowMessageComponent,
    FlyoutFormSettingsFormOptionsComponent,
    FlyoutFormSettingsResponseListsComponent,
    FlyoutFormSettingsLeaderboardComponent,
    FlyoutFormSettingsEcommerceComponent,
    FlyoutReferralCampaignsComponent,
    FlyoutSubmittedFormComponent,
    FlyoutScoresComponent,
    FlyoutAutomationsComponent,
    FlyoutCampaignFilterComponent,
    FlyoutBrandSettingsComponent,
    FlyoutWidgetPreviewIframeComponent,
    FlyoutCopyBrandSettingsComponent,
    DataPlatformConsentListComponent,
    DataPlatformPurchasesListComponent,
    DataPlatformVisitFlyoutComponent,
    DataPlatformProfileFlyoutComponent,
    DataPlatformContactFlyoutComponent,
    CollapsibleListComponent,
    FlyoutWidgetSelectorFilterComponent,
    FlyoutHoldoutSettingsComponent,
    FlyoutKpiSettingsComponent,
    FlyoutRecommendationComponent,
    FlyoutSiteCheckComponent,
  ],
  providers: [...services, DataPlatformService, FormatDate],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FlyoutModule {}
